import React, { ReactElement, FunctionComponent } from 'react'
import Image from '../BaseComponents/Image'

type AuthorImageProps = {
    imageUrl: string
    alt?: string
}

const AuthorImage: FunctionComponent<AuthorImageProps> = ({ imageUrl, alt }): ReactElement => {
    return <Image size="L" radiusType="circled" imageUrl={imageUrl} alt={alt} width="100%" />
}
export default AuthorImage
